module.exports = __webpack_public_path__ + "static/img/cider.c0419e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cider.jpg
// module id = 291
// module chunks = 1